<template>
    <div>
 
        
           <b-table 
                            :data="isEmpty ? [] : lab_HIS_LIS_Mapping.chemistry"
                            bordered 
                            striped 
                            hoverable 
                            mobile-cards
                            :sticky-header="true"
                            :height="getHeightTbl"
                             >


                                    <b-table-column  label="Abbreviation"   v-slot="props">
                                        {{ getNameFullnameFromFieldKey_CBC(props.row.field_name).nick_name }}
                                    </b-table-column>

                                    <b-table-column  label="Parameter"   v-slot="props">
                                        {{ getNameFullnameFromFieldKey_CBC(props.row.field_name).full_name }}
                                    </b-table-column>

                                    <b-table-column  label="Value"  v-slot="props"   >
                                           <b-input type="number"
                                                v-model="props.row.val"
                                        ></b-input>
                                    </b-table-column>



                                    <b-table-column  label="Unit"  v-slot="props" >
                                       <b-input v-model="props.row.unit"  ></b-input> 
                                    </b-table-column>


                                    <b-table-column  label="Ref."  v-slot="props" >
                                       <b-input   v-model="props.row.ref"  ></b-input>
                                    </b-table-column>



                                    <b-table-column  label="Flag"  v-slot="props"  >
                                       <b-input v-model="props.row.flag"  ></b-input> 
                                    </b-table-column>

                                    <b-table-column  label="Machine ID"  v-slot="props"  >
                                       <b-input v-model="props.row.machine_id"  ></b-input> 
                                    </b-table-column>



                            <template slot="empty">
                                    <section class="section">
                                        <div class="content has-text-grey has-text-centered">
                                            <p>
                                                <b-icon
                                                    icon="emoticon-sad"
                                                    size="is-large">
                                                </b-icon>
                                            </p>
                                            <p>Nothing here.</p>
                                        </div>
                                    </section>
                            </template>



                </b-table>    
    </div>
</template>


<script>
import { mapState} from "vuex";
import getNameFullnameFromFieldKey_CBC from '../../../mixins/methods/getNameFullnameFromFieldKey_CBC'

export default {
    name : "BlChemParam",
    props:{
        // mode : Number,  // 0 ----> input mode  , 1 -----> set default unit && ref mode
    },
    mixins:[getNameFullnameFromFieldKey_CBC,],
    mounted(){
      
      
        this.windowHeight = window.innerHeight;
        this.outerWindowHeight = window.outerHeight;
         


        if(this.mode == 0){
           this.dataBC = this.lab_HIS_LIS_Mapping['chemistry']
        }else{
           // first thing first 
           // assign blank into every field   
           this.dataBC = this.lab_HIS_LIS_Mapping['chemistry'] //this.dataToEdit
           // update edit
            //    for(var i =0;i<=this.dataToEdit.length-1;i++){
            //      const tmp = this.dataHM.find(dat=>dat.field_name == this.dataToEdit[i].field_name)   
            //      if(tmp){
            //       tmp.val =  this.dataToEdit[i].val
            //       tmp.unit =  this.dataToEdit[i].unit
            //       tmp.ref =  this.dataToEdit[i].ref
            //       tmp.flag =  this.dataToEdit[i].flag
            //       tmp.machine_id =  this.dataToEdit[i].machine_id
            //      }
            //    }   

        //      for(var i =0;i<=this.dataBC.length-1;i++){
        //                 // clear all
        //                 // keep param
        //                 this.dataBC[i].val  = null
        //                 this.dataBC[i].unit  = ""
        //                 this.dataBC[i].ref  = "" 
        //                 this.dataBC[i].flag   = ""
        //                 this.dataBC[i].machine_id   = ""

        //                 const tmp = this.dataToEdit_ManuallyLabAutomate.find(dat=>dat.field_name == this.dataBC[i].field_name)   
        //                 if(!tmp){
        //                     console.log('--->',);
        //                 this.dataBC[i].val =  tmp.val
        //                 this.dataBC[i].unit =  tmp.unit
        //                 this.dataBC[i].ref =  tmp.ref
        //                 this.dataBC[i].flag = tmp.flag
        //                 this.dataBC[i].machine_id =  tmp.machine_id
        //                 } 
        //    } 

        }
    },
    
    computed:{
            ...mapState({
                // dataModelMNLABAutomate: state => state.manually_create_lab_automate.dataModelMNLABAutomate ,
                lab_HIS_LIS_Mapping: state => state.manually_create_lab_automate.lab_HIS_LIS_Mapping ,
                mapField_Fullname : state => state.manually_create_lab_automate.mapField_Fullname ,
                dataToEdit_ManuallyLabAutomate: state => state.manually_create_lab_automate.dataToEdit_ManuallyLabAutomate ,
            }),
         
            getHeightTbl(){
                return  this.windowHeight=='' ? 0 : this.windowHeight
            }

    },

    beforeDestroy() {
   
    },
    methods:{
 
    },
    data(){
        return {
             
             isEmpty : false,



            windowHeight : "",
            outerWindowHeight : ""

             
        }
    }
}
</script>